export default __webpack_public_path__ + "static/media/show2.09bbbccd.jpg";